import Parse from "parse";
import { getLocale } from "src/utils/locale";
import environment, { getEnvironmentVariable } from "src/utils/environment";

const log = window.require("electron-log");
const { app } = window.require("@electron/remote");

export default async function updateInstallationInfo() {
  try {
    const locale = getLocale().slice(0, 2);

    const parseSession = await Parse.Session.current();
    const installationId = parseSession.attributes.installationId;

    if (!parseSession) return;

    const installationData = {
      localeIdentifier: `${locale.toUpperCase()}_`,
      deviceType: "desktop",
      appVersion: app?.getVersion() || "browser",
      systemVersion: navigator.appVersion,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      appIdentifier: `com.tappytaps.desktop.${environment.appName}`,
      installationId
    };

    await fetch(
      `${getEnvironmentVariable("PARSE_SERVER_URL")}/classes/_Installation`,
      {
        body: JSON.stringify({
          _SessionToken: parseSession.attributes.sessionToken,
          _ApplicationId: getEnvironmentVariable("PARSE_APP_ID"),
          ...installationData
        }),
        method: "POST"
      }
    );
  } catch (err) {
    log.error("Failed updating installation info");
  }
}
